// api/indicatorData.js
import { http } from './http';

/**
 * READ (list) — adapter shaped for useListQuery
 * params: { page, size, sortBy, sortDir, q, filters:{ indicator, geoUnit, date, subvalueType } }
 * returns: { rows, total }
 */
export async function readIndicatorData(params) {
    const { filters, ...flatParams } = params || {};
    const requestParams = { ...flatParams, ...(filters || {}) };
    const { data } = await http.get('/indicator-data', { params: requestParams });
    const raw = Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : []);

    const rows = raw.map(x => ({
        id: x.dataId,
        indicatorId: x.indicatorId,
        indicator: x.indicatorName,
        geoUnitId: x.geoUnitId,
        geoUnit: x.geoUnitName,
        date: x.date,
        value: x.value,
        subvalueType: x.subvalueType,
        subvalue: x.subvalue,
        ...x,
    }));

    const total = Number.isFinite(data?.total) ? data.total : (data?.meta?.total ?? rows.length);
    return { rows, total };
}

/** READ (single) */
export async function getIndicatorData(id, { etag } = {}) {
    const { data, etag: nextEtag } = await http.get(`/indicator-data/${id}`, { etag });
    const result = data && typeof data === 'object'
        ? { id: data.dataId ?? data.indicatorDataId ?? data.id, ...data }
        : data;
    return { data: result, etag: nextEtag };
}

/** CREATE */
export const createIndicatorData = (payload) =>
    http.post('/indicator-data', { body: payload }).then(r => r.data);

/** UPDATE (partial) */
export const updateIndicatorData = (id, patch) =>
    http.patch(`/indicator-data/${id}`, { body: patch }).then(r => r.data);

/** REPLACE (full) */
export const replaceIndicatorData = (id, body) =>
    http.put(`/indicator-data/${id}`, { body }).then(r => r.data);

/** DELETE */
export const deleteIndicatorData = (id) =>
    http.delete(`/indicator-data/${id}`).then(() => ({ ok: true }));

/** Taxonomies / helpers (list items: indicator, geoUnit, date, subvalueType) */
export const listIndicatorDataIndicators = () =>
    http.get('/indicator-data/indicators').then(({ data }) => (Array.isArray(data) ? data : []));

export const listIndicatorDataGeoUnits = () =>
    http.get('/indicator-data/geo-units').then(({ data }) => (Array.isArray(data) ? data : []));

export const listIndicatorDataSubvalueTypes = () =>
    http.get('/indicator-data/subvalue-types').then(({ data }) => (Array.isArray(data) ? data : []));
